var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconWallet(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_436_",
    d: "M23.3003 18V19.875C23.3003 20.9093 22.4588 21.75 21.4253 21.75H5.30029C3.64579 21.75 2.30029 20.4045 2.30029 18.75C2.30029 18.75 2.30029 6.01125 2.30029 6C2.30029 4.3455 3.64579 3 5.30029 3H19.1753C19.797 3 20.3003 3.504 20.3003 4.125C20.3003 4.746 19.797 5.25 19.1753 5.25H5.30029C4.88704 5.25 4.55029 5.586 4.55029 6C4.55029 6.414 4.88704 6.75 5.30029 6.75H21.4253C22.4588 6.75 23.3003 7.59075 23.3003 8.625V10.5H19.5503C17.4825 10.5 15.8003 12.1823 15.8003 14.25C15.8003 16.3177 17.4825 18 19.5503 18H23.3003Z",
    fill: "url(#paint0_linear_4109_817)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_438_",
    d: "M23.3003 12V16.5H19.5503C18.3075 16.5 17.3003 15.4927 17.3003 14.25C17.3003 13.0073 18.3075 12 19.5503 12H23.3003Z",
    fill: "url(#paint1_linear_4109_817)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4109_817",
    x1: 12.8003,
    y1: 3,
    x2: 12.8003,
    y2: 21.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F00F11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CC0D0E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4109_817",
    x1: 20.3003,
    y1: 12,
    x2: 20.3003,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F00F11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#CC0D0E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWallet);
export default __webpack_public_path__ + "static/media/icon_wallet.023bd1dccbdc05b353096706cb5f8763.svg";
export { ForwardRef as ReactComponent };